import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import GitHubIcon from '@mui/icons-material/GitHub';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import config from '../config.json';

const { support } = config;

function Contact() {
  const theme = useTheme();

  return (
    <Box
      id="contact"
      sx={{
        py: { xs: 10, md: 14 },
        background: theme.custom.sectionTint,
      }}
    >
      <Container maxWidth="sm">
        <Box sx={{ textAlign: 'center' }}>
          <SupportAgentIcon
            sx={{ fontSize: 48, color: 'primary.main', mb: 2 }}
          />
          <Typography
            variant="overline"
            sx={{
              color: 'primary.main',
              fontWeight: 600,
              letterSpacing: 3,
              fontSize: '0.85rem',
            }}
          >
            {support.overline}
          </Typography>
          <Typography variant="h2" sx={{ mt: 1, mb: 2 }}>
            {support.heading}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: 'text.secondary',
              maxWidth: 500,
              mx: 'auto',
              mb: 4,
            }}
          >
            {support.description}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<GitHubIcon />}
            href={config.urls.githubSupport}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ px: 4, py: 1.5 }}
          >
            {support.buttonLabel}
          </Button>
        </Box>
      </Container>
    </Box>
  );
}

export default Contact;
